<template>
  <div>
    <div id="home"></div>
    <v-container class="screen3 room">
      <v-layout row wrap>
        <v-flex xs12 md6>
          <div class="room-block">
            <v-layout row wrap>
              <gallery :images="room.images" :index="room.index" @close="room.index = null"></gallery>
              <v-flex xs6
                v-for="(image, imageIndex) in room.images"
                :key="imageIndex"
              >
              <v-img class="gallery-img"
                aspect-ratio="1"
                @click="room.index = imageIndex"
                :style="{backgroundImage: 'url(' + image + ')'}">
              </v-img>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
        <v-flex xs12 md6>
          <div class="room-block">
            <h2>{{ room.name }}</h2>
            <h3 class="room-price">{{ room.price }}</h3>
            <app-modal-form
              button-text="Забронировать номер"
              modal-form-header="Забронируйте"
              modal-form-sub-header="номер прямо сейчас"
              modal-form-button-text="Забронировать номер"
              :form-name="'Садко - ' + room.name"
            ></app-modal-form>
            <div class="room-text" v-html="room.description2"></div>
            <div>{{ room.description3 }}</div>
            <div class="room-text"><b>СТОИМОСТЬ НОМЕРА:</b></div>
            <div>{{ room.price }}</div>
            <div>{{ room.price2 }}</div>
            <div>{{ room.price3 }}</div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <app-sadko-reviews></app-sadko-reviews>
    <app-sadko-contacts></app-sadko-contacts>
    <app-button-go-back :goto="goto"></app-button-go-back>

  </div>
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  data () {
    return {
      goto: { path: '/sadko/rooms' }
    }
  },
  props: ['id'],
  computed: {
    room () {
      const id = this.id
      return this.$store.getters.malinaRoomById(id)
    }
  },
  components: {
    'gallery': VueGallery
  }
}
</script>

<style scoped>
.room-block {
  margin: 15px;
}

.room-price {
  margin: 15px 0px;
  color: green;
}

.room-text {
  margin: 15px 0px;
}

.gallery-img {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.gallery-img:hover {
  opacity: 0.8;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {

}

</style>



// WEBPACK FOOTER //
// src/components/pages/sadko/Room.vue